import React from 'react';
import { IconX } from '../../assets/icons';
import parse from 'html-react-parser';
import cn from 'classnames';
import './AlertModal.scss';

type VariantType = 'warning' | 'primary' | 'info' | 'danger' | 'default' | 'success';

interface AlertModalProps {
    id?: string;
    className?: string;
    label: string;
    variant?: VariantType;
    onClick: (anything?: any) => void;
}

const classes = {
    danger: 'vacasa-alert-danger',
    default: 'vacasa-alert-default',
    info: 'vacasa-alert-info',
    primary: 'vacasa-alert-primary',
    success: 'vacasa-alert-success',
    warning: 'vacasa-alert-warning',
};

export const AlertModal: React.FC<AlertModalProps> = (props) => {
    const { id, label, variant, className } = props;
    const vacasaVariant = variant ? classes[variant] : classes.default;

    return (
        <div id={`main-${id}`} className={cn(className && className, `d-flex base-box w-100 ${vacasaVariant}`)}>
            <div className={`d-flex justify-content-start message-box`}>
                <span className={'font-alert-msg'}>{parse(label)}</span>
            </div>
            <div className={`d-flex justify-content-end w-auto mr-21`}>
                <IconX onClick={() => props.onClick()} />
            </div>
        </div>
    );
};
